import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const FileUploadingProgress = ({ percentage }) => (
  <div styleName="file-progress">
    <div styleName="file-progress__bar">
      <span
        data-test="file-progress-bar"
        style={{ width: `${percentage}%` }}
        styleName="file-progress__uploading-bar"
      />
    </div>
    <span
      data-test="file-progress-percentage"
      styleName="file-progress__percentage"
    >
      {percentage}%
    </span>
  </div>
);

FileUploadingProgress.propTypes = {
  percentage: PropTypes.number,
};

export default FileUploadingProgress;
